module.exports = __webpack_public_path__ + "static/img/6c.09f1d69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6c.jpg
// module id = GE54
// module chunks = 1